import {
    ConfigurationItemArrayEditor,
    configurationItemArrayEditorRules,
} from '@client/components/_core/configuration/ConfigurationItemArrayEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Space } from 'antd';
import { ScrollText } from 'lucide-react';
import { LegislationItems } from './LegislationItems';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/obligations')({
    staticData: {
        metadata: {
            title: 'Obligations',
        },
        ui: {
            icon: ScrollText,
            title: 'Obligations',
            subtitle: 'Legislation items and regulator/source options',
            menuDescription: 'Legislation items and regulator/source options',
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
    },
    component: Obligations,
});

function Obligations() {
    return (
        <PageController route={Route}>
            <Space orientation="vertical" size="middle" className="w-full">
                <LegislationItems />
                <ConfigurationItemArrayEditor
                    title="Regulators"
                    settingToEdit="OBLIGATION_REGULATORS"
                    description="Add, rename, or remove regulator/source options for obligations."
                    minItems={1}
                    arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                    itemRules={[{ required: true, message: 'Field is required' }]}
                />
            </Space>
        </PageController>
    );
}
